// Stacking guide: single source of truth for all z-index layers.
// Every layer listed here maps to the exact value it always had, so switching
// from inline literals to these names is a pure refactor (no stacking change).
// Keep layers in low-to-high order and reuse these names everywhere instead of
// inline numbers, so overlays/modals/dropdowns stack consistently.
export const zIndex = {
	base: 1,
	popover: 2,
	tab: 10,
	// Sticky rows and app chrome (page headers / top bars / sidebars).
	tableStickyHeader: 99,
	stickyHeader: 100,
	sidebar: 101,
	topRow: 104,
	appHeader: 105,
	aboveHeader: 106,
	// Floating tooltips / inline error bubbles.
	tooltip: 200,
	errorTooltip: 202,
	// Dropdown menus and their full-screen click-catchers.
	dropdownBackdrop: 298,
	dropdown: 300,
	// Modal dialogs: the scrim sits on modalBackdrop, the panel on modal above it.
	modal: 305,
	modalBackdrop: 310,
	modalElevated: 311,
	// Highest layer: full-screen loading scrims.
	loadingOverlay: 320,
};